import React from 'react';
import { connect } from 'redux-bundler-react';
import SidebarButton from './project-sidebar-button';

class SidebarPanelOpenerButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open || false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(newProps){
    const { primaryPanelOpenedBy, title } = newProps;
    if(primaryPanelOpenedBy !=='ds-tree' &&  primaryPanelOpenedBy !== title && this.state.open) this.setState({ open: false });
  }
  componentDidMount(){
    const { doOpenPrimaryPanel, title, panelComponent, panelOptions } = this.props;
    const{open} = this.state;
    if(open === true) {
      doOpenPrimaryPanel({
        openedBy: title,
        options: panelOptions,
        children:[ panelComponent ]
      })
    }
  }
  handleClick(){
    const { doOpenPrimaryPanel, doClosePrimaryPanel, title, panelComponent, panelOptions } = this.props;
    this.setState({
      open: !this.state.open
    }, () => {
      if(this.state.open){
        doOpenPrimaryPanel({
          openedBy: title,
          options: panelOptions,
          children:[ panelComponent ]
        })
      }else{
        doClosePrimaryPanel()
      }
    })
  }

  render() {
    const { theme, label, title, iconClass, iconText, styleOverride } = this.props;
    const { open } = this.state;

    return (
      <SidebarButton
        active={open}
        iconClass={iconClass}
        iconText={iconText}
        styleOverride={styleOverride}
        expanded={ false }
        label={label}
        title={title}
        onClick={this.handleClick}
        theme={theme}
      />
    );
  }
}

export default connect(
  'selectTheme',
  'selectPrimaryPanelOpenedBy',
  'doOpenPrimaryPanel',
  'doClosePrimaryPanel',
  SidebarPanelOpenerButton
);